import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConsentsService } from '../services';
import type { IAcceptAllOfficeConsentsParameters } from '../types/OfficeConsent.parameters';
import { showErrorMessage } from '~/domain/utils';

interface IUseAcceptAllOfficeConsents {
  onError?: () => void;
  onSuccess?: () => void;
}

export const useAcceptAllOfficeConsents = ({ onError, onSuccess }: IUseAcceptAllOfficeConsents) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: IAcceptAllOfficeConsentsParameters) =>
      ConsentsService.acceptAllOfficeConsents(params),
    onSuccess(_data, variables) {
      // Invalidate the specific office consent query after accepting
      queryClient.invalidateQueries({
        queryKey: ['GET_OFFICE_CONSENT', variables.officeId, variables.code],
      });

      onSuccess?.();
    },
    onError(error) {
      onError?.();
      showErrorMessage({ error });
    },
  });
};
